import { useConfigStore } from "@/stores/config";
import { REFERENCE_TABLE } from "@/constants/ReferenceTables";
import { locationOptions, getFcDetailsReport } from "@/composables/NSTMFatigueData";

export const getNSTMFatigueDocDefinition = (unitKey) => {
  const configStore = useConfigStore();

  const fcDetails = getFcDetailsReport(unitKey);

  const NSTMFatigueTable = [];
  for (const detail of fcDetails ?? []) {
    NSTMFatigueTable.push(getNSTMFatigueTableHeader(), 
    [
        detail?.fcKey,
        {
          text: locationOptions(detail?.strUnitKey),
          style: ["tableBody"],
        },
        {
          text: configStore.getReferenceValue(REFERENCE_TABLE.FRACTURE_CRITICAL_MEMBER_TYPE, detail?.fcMemType),
          style: ["tableBody"],
        },
        detail?.fcDetail,
        detail?.fatigStressCat,
        detail?.nstmDetailPresent,
      ].map((d) => {
        return {
          text: d,
          alignment: "center",
        };
      }),
    [
      {
        colSpan: 6,
        margin: [3, 3, 0, 10],
        text: [
          {
            text: "NF.14 Member: ",
            bold: true,
          },
          {
            text: detail?.fcMem,
          },
        ],
      },
    ],
    [
      {
        colSpan: 6,
        margin: [3, 3, 0, 10],
        text: [
          {
            text: "NF.15 Member Detail Condition: ",
            bold: true,
          },
          {
            text: detail?.fcDescription,
          },
        ],
      },
    ],
    [
      {
        colSpan: 6,
        margin: [3, 3, 0, 10],
        text: [
          {
            text: "NF.16 Member Inspection Procedure: ",
            bold: true,
          },
          {
            text: detail?.detailInspProc,
          },
        ],
      },
    ]);
  }
  if (NSTMFatigueTable.length === 0) {
    NSTMFatigueTable.push([{ text: "", colSpan: 7 }, {}, {}, {}, {}, {}, {}]);
  }
  return {
    table: {
      headerRows: 0,
      widths: ["8%", "12%", "15%", "20%", "20%", "15%", "10%"],
      body: NSTMFatigueTable,
    },
    margin: [0, 5, 0, 0],
  };
};

function getNSTMFatigueTableHeader() {
  return [
    {
      text: "NF.08\n Key",
      style: ["tableHeader"],
    },
    {
      text: "NF.09\n Location",
      style: ["tableHeader"],
    },
    {
      text: "NF.11\n Member\n Type",
      style: ["tableHeader"],
    },
    {
      text: "NF.12\n Member Detail",
      style: ["tableHeader"],
    },
    {
      text: "NF.10\n Member Stress\n Category",
      style: ["tableHeader"],
    },
    {
      text: "NF.13\n Detail Type",
      style: ["tableHeader"],
    },
  ];
}
